module.exports = __webpack_public_path__ + "img/63-1.b81ed701.png";